import styled from 'styled-components';
import getMeasureValue from '../../../helpers/get-measure-value.ts';
import type FlexContainerProps from './types/flex-container-props';

const FlexContainer = styled.div<FlexContainerProps>`
  ${(props: FlexContainerProps) => `
    display: flex;
    justify-content: ${props.justifycontent || 'flex-start'};
    font-size: ${getMeasureValue(props?.fontSize, 'inherit')};
    ${props?.width !== null && props?.width !== undefined ? `width: ${getMeasureValue(props.width)};` : ''}
    ${props?.height !== null && props?.height !== undefined ? `height: ${getMeasureValue(props?.height)};` : ''}
    ${props?.margin !== null && props?.margin !== undefined ? `margin: ${getMeasureValue(props.margin)};` : ''}
    ${props?.marginTop !== null && props?.marginTop !== undefined ? `margin-top: ${getMeasureValue(props.margin)};` : ''}
    ${props?.marginBottom !== null && props?.marginBottom !== undefined ? `margin-bottom: ${getMeasureValue(props.margin)};` : ''}
    ${props?.marginLeft !== null && props?.marginLeft !== undefined ? `margin-left: ${getMeasureValue(props.margin)};` : ''}
    ${props?.marginRight !== null && props?.marginRight !== undefined ? `margin-right: ${getMeasureValue(props.margin)};` : ''}
    ${props?.padding !== null && props?.padding !== undefined ? `padding: ${props.padding};` : ''}
    ${props?.backgroundColor ? `background-color: ${props.backgroundColor};` : ''}
    ${props?.borderradius ? `border-radius: ${props.borderradius};` : ''}
    ${props?.overflow ? `overflow: ${props.overflow};` : ''}
    ${props?.overflowx ? `overflow-x: ${props.overflowx};` : ''}
    ${props?.minWidth ? `min-width: ${getMeasureValue(props.minWidth)};` : ''}
    ${props?.maxWidth ? `max-width: ${getMeasureValue(props.maxWidth)};` : ''}
    ${props?.flexdirection ? `flex-direction: ${props.flexdirection};` : ''}
    ${props?.alignitems ? `align-items: ${props.alignitems};` : ''}
    ${props?.alignself ? `align-self: ${props.alignself};` : ''}
    ${props?.gap !== null && props?.gap !== undefined ? `gap: ${getMeasureValue(props.gap)};` : ''}
    ${props?.flexWrap ? `flex-wrap: ${props.flexWrap};` : ''}
    ${props?.flexGrow ? `flex-grow: ${props.flexGrow};` : ''}
    ${props?.borderBottom ? `border-bottom: ${props.borderBottom};` : ''}
    ${props?.outline ? `outline: ${props.outline};` : ''}
    ${props?.color ? `color: ${props.color};` : ''}
    ${props?.fontWeight ? `font-weight: ${props.fontWeight};` : ''}
    ${props?.lineheight ? `line-height: ${props.lineheight};` : ''}
    ${props?.transform ? `transform: ${props.transform};` : ''}
    ${props?.zindex ? `z-index: ${props.zindex};` : ''}
  `}
`;

export default FlexContainer;
